import React from "react";
import { Container, Form } from "react-bootstrap";
import TopHeader from "../Common/TopHeader";
import { useForm } from "react-hook-form";
import { DisplayErrorMessages, DisplayToaster, PostApiMethod } from "../../core/services/apiService";



const Settings = () => {

    const { register, handleSubmit, resetField, formState: { errors }, setError } = useForm<any>();
    const [fileValidation, setFileValidation] = React.useState(false);
    const [existingDocs, setExistingDocs] = React.useState();
    const [id, setId] = React.useState();
    const [isLoading, setLoading] = React.useState<boolean>(false);
    React.useEffect(() => {
        if (!id) {
            PostApiMethod('admin/settings/uploads', {}).then((result: any) => {
                setExistingDocs(result.data?.data?.Docs);
                setId(result.data.data._id);
            }).catch((err) => {
                console.log(err);
            });
        }
    }, []);

    const documents = [
        {
            name: "customerAdminAgents", heading: "Customer Admin - Agents"
        },
        {
            name: "customerAdminLocations", heading: "Customer Admin - Locations"
        },
        {
            name: "customerAdminKiosks", heading: "Customer Admin - Kiosks"
        },
        {
            name: "customerAdminSettings", heading: "Customer Admin - Settings"
        },
        {
            name: "agentDashboard", heading: "Agent - Dashboard"
        },
        {
            name: "agentTeam", heading: "Agent - Team"
        },
        {
            name: "agentReport", heading: "Agent - Report"
        }
    ];
    const allowedImageExtensionTypes: string[] = ['pdf', 'txt', 'xls', 'ppt', 'odt', 'doc'];

    const handleImageType = React.useCallback((event: any) => {
        const fileType = event.target.files[0]?.name?.split(".").at(-1);
        if ((fileType && !allowedImageExtensionTypes.includes(fileType))) {
            setFileValidation(true);
            resetField(event?.target?.name);
            DisplayToaster("bg-danger", "File type is not supported. The supported File types are " + allowedImageExtensionTypes.join(", "));
        } else {
            setFileValidation(false);
        }
    }, []);

    const resetInputFields = (data: any) => {
        data.map((item: any) => resetField(item.name))
    }

    const handleRegistration = (data: any) => {
        setLoading(true);
        const form_Data = new FormData();
        documents.forEach((item) => {
            form_Data.append(item.name, (data[item.name] ? data[item.name][0] : ""))
        });
        PostApiMethod('admin/settings/uploadDocs/' + id, form_Data, {
            headers: {
                "Content-Type": "multipart/form-data",
            },
        }).then((result: any) => {
            resetInputFields(documents);
            setExistingDocs(result.data?.data?.Docs);
            setLoading(false)
            if (result.data?.status === "Success" || result?.status === 201) {
                DisplayToaster("bg-success", "Document uploaded successfully");
            }
        }).catch((err) => {
            console.log(err);
            DisplayToaster("bg-danger", DisplayErrorMessages(err) ? DisplayErrorMessages(err) : "Something went wrong!");
            setLoading(false)
        })
    };

    return (
        <>
            <Container fluid>
                <TopHeader
                    heading="Settings"
                    to={"/settings"}
                    className="fa-list"
                    action="List"
                    id="settings"
                />

                <Form onSubmit={handleSubmit(handleRegistration)}>
                    <div className="text-center">
                        <small className="text-danger mb-3"><b>Supported Formats : {allowedImageExtensionTypes.join(", ")}</b> </small><br />
                    </div>
                    {
                        documents.map((item, index) => (
                            <>
                                <div className="col-8 row mt-3">
                                    <div className="col-6"><b>{item.heading}</b></div>
                                    <div className="col-6">
                                        <input type="file" id="fileInput" accept='.doc,.pdf,.txt' className="form-control" {...register(item.name, { onChange: (e) => { handleImageType(e) } })} />
                                        <small>Available Document : {(existingDocs && existingDocs[item.name]) ? <a target="_blank" href={existingDocs[item.name]}>{item.heading}</a> : <span className="text-danger">Not Available Please Upload one.</span>}</small>
                                    </div>
                                </div>
                            </>
                        ))
                    }
                    <div className="text-center mt-3">
                        <button type="submit" disabled={isLoading} className="btn btn-primary">{isLoading &&
                            <span className="spinner-border text-white mr-1" style={{ width: '18px', height: "18px" }} role="status"></span>
                        }{" "}Upload</button>
                    </div>
                </Form>


            </Container>
        </>

    )
}

export default Settings;